import { useScrollReveal } from '@/hooks/useScrollReveal';

const features = [
  {
    icon: 'ri-book-read-line',
    title: '下拉式畅快阅读',
    desc: '触手漫画网采用下拉式阅读模式，告别翻页烦恼。一滑到底，沉浸式体验触手漫画的每一页精彩内容，让阅读更加流畅自然。',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量触手漫画全集',
    desc: '收录 2000+ 触手题材漫画作品，涵盖连载、完结、新作等多种类型。每日实时更新，触手漫画爱好者的专属图书馆，找漫不迷路。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '安全纯净无广告',
    desc: '触手漫画网坚持纯净阅读环境，无弹窗广告、无恶意跳转。专注于提供优质的触手漫画在线看体验，保护每一位读者的阅读安全。',
  },
];

export default function FeaturesSection() {
  const { ref: titleRef, visible: titleVisible } = useScrollReveal(0.12);

  return (
    <section id="features" className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div ref={titleRef} className={`text-center mb-12 ${titleVisible ? 'animate-fade-in-up' : 'animate-initial-hidden'}`}>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100/60 border border-secondary-200/50 mb-4">
            <i className="ri-star-line text-secondary-600 text-xs w-4 h-4 flex items-center justify-center"></i>
            <span className="text-xs font-medium text-secondary-700 whitespace-nowrap">为什么选择我们</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            本站特色
          </h2>
          <div className="w-16 h-0.5 bg-primary-500 mx-auto mb-4"></div>
          <p className="text-sm md:text-base text-foreground-600">
            为什么选择触手漫画网？三大特色为你解答
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, idx) => (
            <FeatureCard key={idx} feature={feature} idx={idx} />
          ))}
        </div>
      </div>
    </section>
  );
}

function FeatureCard({ feature, idx }: { feature: typeof features[0]; idx: number }) {
  const { ref, visible } = useScrollReveal(0.08);

  return (
    <div
      ref={ref}
      className={`bg-background-50 rounded-lg border border-background-200/60 p-6 md:p-8 text-center group hover:border-primary-300 transition-all ${
        visible ? `animate-fade-in-up animate-stagger-${idx + 1}` : 'animate-initial-hidden'
      }`}
    >
      <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-colors">
        <i className={`${feature.icon} text-2xl`}></i>
      </div>
      <h3 className="text-base font-semibold text-foreground-900 mb-3">{feature.title}</h3>
      <p className="text-sm text-foreground-600 leading-relaxed">{feature.desc}</p>
    </div>
  );
}